import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { InboxImage } from "../../components/icons";
import PrimaryTitle from "../../components/PrimaryTitle";
import NoContent from "../../components/NoContent";
import t from "../../service/translate.service";
import PropTypes from "prop-types";
import iconsArrowRight from "../../assets/svg/iconsArrowRight.svg";
import IconsCloseSmall from "../../assets/svg/iconsCloseSmall.svg";
import moment from "moment";
import RepairsAndIquiriesStore from "../../store/repairsAndInquiries.store";
import { getAlertInfo, prepareContent } from "../../service/alert.service";
import withRouter from "../../components/withRouter";
import { Link } from "react-router-dom";
import { appFeatureEnabled } from "../../service/appFeatures.service";

class InboxPage extends Component {
  static contextTypes = {
    user: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props);
    this.store = new RepairsAndIquiriesStore();
    this.store.getReports();
  }

  handleClick = (type) => {
    this.props.alertStore.selectedCategory = type;
  };

  openReport = (id, link) => {
    if (id === 'dob' && this.props.alertStore.selectedCategory === "general") {
      this.props.menuStore.setCurrentPage("/");
      localStorage.setItem('forceDob', 'true')
    }
    if (this.props.alertStore.selectedCategory === "damage_report") {
      const selectedReport = this.store.reports.filter((r) => r.id === id)[0];
      this.store.selectedReport = selectedReport;
      this.props.menuStore.setCurrentPage("/repairs-and-inquiries");
    }
    if (this.props.alertStore.selectedCategory === "oc_inspection") {
      this.props.menuStore.setCurrentPage("/receipt-inspection");
    }
    if(this.props.alertStore.selectedCategory === "contract") {
      this.props.menuStore.setCurrentPage("/contracts");
    }
    if (link) {
      this.props.navigate(link)
    }

  };

  generateLink = (type, contractNumber, reportId) => {
    let link = ''
    if (type === 'certificate') {
      if (appFeatureEnabled("rentContractDocumentsEnabled")) {
        link = `/rent-contract-documents/${contractNumber}`
      }
    } else {
      switch (this.props.alertStore.selectedCategory) {
        case 'damage_report':
          link = '/repairs-and-inquiries'
        break
        case 'oc_inspection':
          link = '/receipt-inspection'
        break
        case 'contract':
          link = '/contracts'
        break
        case 'general':
          if (reportId === 'dob') {
            link = '/'
          }
        break
        case 'vouchers':
          if (appFeatureEnabled("vouchersEnabled") && contractNumber) {
            link = `/vouchers?contractNumber=${contractNumber}`
          }
        break
        default:
          link = ''
      }
    }
    return link
  }

  extractContractNumberFromAlert = (content) => {
    if (!content || typeof content !== 'string') return; 
    const regex = /<b>(.*?)<\/b>/
    const matches = content.match(regex)
    if (!matches) return;
    return matches[1].trim()
  }

  renderInboxAlert = (alert) => {
    if (alert.type !== this.props.alertStore.selectedCategory) return;
    if(!appFeatureEnabled('verificationEnabled') && alert.status === 'UNVERIFIED') {
      alert.status = 'VERIFIED'
    }
    let {statusClass, content, sName, isUrl, lang} = getAlertInfo(alert)
    content = content?.replace('<p hidden="">long</p>', '')
    const contractNumber = this.extractContractNumberFromAlert(content)
    const alertLink = this.generateLink(alert.type, contractNumber, alert?.reportId)

    return (
      <div className="item" style={{ marginBottom: '10px' }} key={alert.id || Date.now()}>
        <button 
          className={`container ${(alert?.type === 'contract' || alert?.type === 'damage_report' || alert?.reportId === 'dob') ? 'openAlert' : ''}`}
          onClick={() => {
            this.props.alertStore.markAlertRead(alert.id);
            this.openReport(alert.reportId, alertLink);
          }}
          style={{ cursor: alertLink ? 'pointer' : 'auto', textAlign: 'left' }}
          >
          <div className="details">
            <div className="group">
              <div className="status">
                <span className={`status ${statusClass}`}>
                  {t[statusClass]}
                </span>{" "}
                {sName} {!alert.seen && <span className="new">{t.NEW}</span>}
              </div>
              {!isUrl ? (
                <div
                  className="contract-number"
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                ></div>
              ) : (
                <div>
                  <p>{prepareContent({...alert, content})}</p>
                </div>
              )}

              <div className="date">
                {moment(alert.created_at)
                  .lang(
                    `${localStorage.getItem("locale") === "de" ? "de" : "en"}`
                  )
                  .format("dddd, MMMM Do YYYY, HH:mm")}
              </div>
            </div>
            {(this.props.alertStore.selectedCategory === "damage_report" || (this.props.alertStore.selectedCategory === "general" && alert?.reportId === 'dob')) && (
              <div className="icon next">
                <img src={iconsArrowRight} />
              </div>
            )}
          </div>
          {alert?.id && (
            <Link
              className="close"
              style={{ padding: '.5rem' }}
              onClick={(e) => {
                e.stopPropagation()
                this.props.alertStore.deleteAlert(alert.id);
              }}
            >
              <img src={IconsCloseSmall} />
            </Link>
          )}
        </button>
      </div>
    );
  };

  render() {
    const categoryStyle = {
      paddingRight: 30,
    };
    let { alerts, categories, selectedCategory } = this.props.alertStore;
    alerts = alerts?.filter((a) => {
      if (!a?.content?.includes('<p hidden>short</p>')) {
        return {
          ...a,
          content: a?.content?.replace('<p hidden>long</p>', ''),
          contentDe: a?.contentDe?.replace('<p hidden>long</p>', '')
        }
      }
      
    })
    return (
      <div>
        <PrimaryTitle title={t.INBOX_TITLE} />
    
        {!alerts.length && (
          <NoContent 
            message={t.INBOX_EMPTY} 
            image={InboxImage} 
            aria-live="polite"
          />
        )}
    
        {!!alerts.length && (
          <div className="category-tabs" role="tablist">
            {categories.map((c) => {
              if (!c.count) return;
              return (
                <Link
                  className={selectedCategory === c.type ? "active" : ""}
                  key={c.type}
                  style={categoryStyle}
                  onClick={(e) => this.props.alertStore.handleClick(e, c.type)}
                  role="tab"
                  aria-selected={selectedCategory === c.type}
                  aria-label={c.name}
                >
                  <h3>{c.name}</h3>
                  {!!c.newCount && <div className="new">{c.newCount}</div>}
                </Link>
              );
            })}
          </div>
        )}
    
        <div className="alert-list" role="region" aria-labelledby="inbox-alerts">
          {alerts.map((alert) => this.renderInboxAlert(alert))}
        </div>
      </div>
    );
  }
}
export function observableWithRouter(component) {
  return withRouter(observable(component));
}

InboxPage.propTypes = {
  menuStore: PropTypes.object.isRequired,
  alertStore: PropTypes.object.isRequired
};
export default inject(
  "alertStore",
  "menuStore"
)(withRouter(observer(InboxPage)));
